import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJuaWNrbmFtZSI6Ilx1NjIzZlx1OGY2Nlx1NzUyOFx1NjIzNzEwMzc1OSIsImF2YXRhciI6Imh0dHBzOlwvXC9pbWcwMS53YW5mYW5nY2hlLmNvbVwvYXZhdGFyXC8wMS5wbmciLCJzZXgiOjAsImxldmVsIjoxMCwiZmFuc19udW0iOjIsImZvbGxvd19udW0iOjQsImlzcnYiOjAsImlzZGVsIjowLCJpc2NhbmNlbCI6MCwiZGVmYXVsdF9ydiI6IiIsInVzZXJfaWQiOjQ0ODMwLCJleHAiOjE2Mjc0NTU4ODl9.3QsnPXBJ4OxrVZ367tpj7HcP_NV820EHx-MFj95pZ0Q',
    userInfo: null,
    cart: null,
    openid: null
  },
  getters: {
    token: (state) => state.token,
    userInfo: (state) => state.userInfo,
    isLoggedin: (state) => Boolean(state.token && state.token.length > 1),
    cart: (state) => state.cart
  },
  mutations: {
    SEVE_USER_INFO (state, userInfo) {
      state.userInfo = userInfo
    },
    SAVE_TOKEN (state, { token }) {
      state.token = token
    },
    CLEAR_TOKEN (state) {
      state.token = null
    },
    SAVE_OPENID (state, { openid }) {
      state.openid = openid
    },
    SAVE_CART (state, { cart }) {
      state.cart = cart
    }
  },
  actions: {
    setUserInfo ({ commit }, userInfo) {
      commit('SEVE_USER_INFO', userInfo)
    },
    setToken ({ commit }, { token }) {
      if (typeof token === 'string' && token && token !== 'null') {
        commit('SAVE_TOKEN', { token })
      }
    },
    clearToken ({ commit }) {
      commit('CLEAR_TOKEN')
    },
    saveOpenid ({ commit }, { openid }) {
      commit('SAVE_OPENID', { openid })
    },
    saveCart ({ commit }, { cart }) {
      commit('SAVE_CART', { cart })
    }
  },
  modules: {
  }
})
